import React, { useState, useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useCookies } from "react-cookie";
import { ToastContainer } from "react-toastify";
import { PrivateRoute, PublicRoute } from "./routes";
import { PRIVATE_GAMES_ENABLED } from "./helpers/privateGames";

import {
  Dashboard,
  Game,
  Home,
  Insights,
  Rules,
  Notifications,
  AllSelections,
  PrivateGame,
  Activity,
  TermsAndConditions
} from "./components/mainComponents";
import "./App.css";
import {
  setToken,
  setAccountId,
  setGameId,
  setOperator,
  setGameServer,
  setCurrency,
  setGameMode,
  setJurisdiction,
  setLocale,
} from "./utils/localStorage";
import SignInModal from "./components/modals/SignInModal/SignInModal";


function App() {
  const [, , removeCookie] = useCookies();
  const [openSignInPopUp, setOpenSignInPopUp] = useState(false);
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (!hasRedirected.current && window.location.pathname === "/") {
      hasRedirected.current = true;
      window.location.replace("/game");
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const accountId = params.get("accountId");
    const gameId = params.get("gameId");
    const operator = params.get("operator");
    const gameServer = params.get("gameServer");
    const currency = params.get("currency");
    const gameMode = params.get("gameMode");
    const jurisdiction = params.get("jurisdiction");
    const locale = params.get("locale");

    if (token) setToken(token);
    if (accountId) setAccountId(accountId);
    if (gameId) setGameId(gameId);
    if (operator) setOperator(operator);
    if (gameServer) setGameServer(gameServer);
    if (currency) setCurrency(currency);
    if (gameMode) setGameMode(gameMode);
    if (jurisdiction) setJurisdiction(jurisdiction);
    if (locale) setLocale(locale);

    const timer = setTimeout(() => {
      if (!token) {
        removeCookie("user_token");
        removeCookie("account_id");
        removeCookie("game_id");
        setOpenSignInPopUp(true);
      } else {
        setOpenSignInPopUp(false);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      {/* <SignInModal visible={openSignInPopUp} /> */}
      <ToastContainer />
      <Routes>
        <Route path="/" element={<PublicRoute />}>
          <Route exact path="/" element={<Home bg={1} />} bg={1} />
        </Route>
        <Route path="/" element={<PublicRoute />}>
          <Route exact path="/insights" element={<Insights />} />
        </Route>
        <Route path="/" element={<PublicRoute />}>
          <Route exact path="/allselections/:id" element={<AllSelections />} />
        </Route>
        <Route exact path="/" element={<PrivateRoute />}>
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route
            exact
            path="/dashboard/allselections"
            element={<AllSelections />}
          />
          <Route exact path="/activity" element={<Activity />} />
          <Route exact path="/notifications" element={<Notifications />} />
          {/* Private games are out of scope for BetArabia. The route stays
              registered so an old bookmark or shared link lands somewhere
              sensible instead of a blank page. */}
          <Route
            exact
            path="/privategame"
            element={
              PRIVATE_GAMES_ENABLED ? <PrivateGame /> : <Navigate to="/game" replace />
            }
          />
        </Route>
        <Route exact path="/" element={<PublicRoute />}>
          <Route exact path="/game" element={<Game />} />
          <Route exact path="/rules" element={<Rules />} />
          <Route
            exact
            path="/termsandconditions"
            element={<TermsAndConditions />}
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
